import React, {useCallback, useEffect, useState} from 'react';
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import {Container} from "react-bootstrap";
import {getAllCompanyLeads} from "../../services/Leadservice";
import LoadingLoginScreen from "../LoadingLoginScreen";
import {dealstages} from "../CONSTANTS";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
);
export const BarStatistics = ({company}) => {

    const [loading, setLoading] = useState(false)

    const [allLeads, setAllLeads] = useState([]);
    const [leadsInCooming, setLeadsInCooming] = useState([]);
    const [leadsSeen, setLeadsSeen] = useState([]);
    const [leadsCompleted, setLeadsCompleted] = useState([]);
    const [leadsDenied, setLeadsDenied] = useState([]);
    const [leadSent, setLeadSent] = useState([]);


    const fetchFilteredLeads = useCallback(async () => {
        try {
            setLoading(true)

            const arr = await getAllCompanyLeads(company);


            setAllLeads(arr);
            const leadIncooming = arr.filter(l => l.dealstage === dealstages.INKOMMENLEAD);
            const leadSent = arr.filter(l => l.dealstage === dealstages.OFFERTSKICKAD)
            const leadSeen = arr.filter(l => l.dealstage === dealstages.OFFERTSEDD)
            const leadAccepted = arr.filter(l => l.dealstage === dealstages.OFFERTGODKAND)
            const leadDenied = arr.filter(l => l.dealstage === dealstages.OFFERTNEKAD)

            setLeadsInCooming(leadIncooming);
            setLeadSent(leadSent);
            setLeadsSeen(leadSeen);
            setLeadsCompleted(leadAccepted);
            setLeadsDenied(leadDenied);


            setLoading(false);

        } catch (e) {
            console.error(e)
        }


    }, [company])

    useEffect(() => {


        fetchFilteredLeads()
    }, [fetchFilteredLeads])


    const options = {
        responsive: true,
        type: 'bar',
        barPercentage: 1.0,


        scales: {},

    };


    const labels = [2022];

    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Totalt Antal Leads',
                data: [allLeads.length],
                hoverBackgroundColor: 'rgba(0, 0, 0, 0.54)',
                backgroundColor: 'rgba(244,164,96, 0.2)',
                borderColor: 'rgba(244,164,96)',
                borderWidth: 1,
                barPercentage: 0.3
            },
            {
                label: 'Totalt Antal Inkomna Leads',
                data: [leadsInCooming.length],
                hoverBackgroundColor: 'rgba(0, 0, 0, 0.54)',
                backgroundColor: 'rgba(82, 145, 202, 0.2)',
                borderColor: 'rgba(82, 145, 202)',
                borderWidth: 1,
                barPercentage: 0.3

            },
            {
                label: 'Totalt Antal Öppnade Offerter',
                data: [leadsSeen.length],
                hoverBackgroundColor: 'rgba(0, 0, 0, 0.54)',
                backgroundColor: 'rgba(210,114,18, 0.2)',
                borderColor: 'rgba(210,114,18)',
                borderWidth: 1,
                barPercentage: 0.3

            },
            {
                label: 'Totalt Antal Skickade Offerter',
                data: [leadSent.length],
                hoverBackgroundColor: 'rgba(0, 0, 0, 0.54)',
                backgroundColor: 'rgba(34,63,119, 0.2)',
                borderColor: 'rgba(34,63,119)',
                borderWidth: 1,
                barPercentage: 0.3

            },
            {
                label: 'Totalt Antal Godkända Offerter',
                data: [leadsCompleted.length],
                hoverBackgroundColor: 'rgba(0, 0, 0, 0.54)',
                backgroundColor: 'rgba(96,194,96, 0.2)',
                borderColor: 'rgba(96,194,96)',
                borderWidth: 1,
                barPercentage: 0.3

            },
            {
                label: 'Totalt Antal Nekade Offerter',
                data: [leadsDenied.length],
                hoverBackgroundColor: 'rgba(0, 0, 0, 0.54)',
                backgroundColor: 'rgba(255,0,0, 0.2)',
                borderColor: 'rgba(255,0,0)',
                borderWidth: 1,
                barPercentage: 0.3


            }
        ],
    };


    return (
        <>
            {loading ? <LoadingLoginScreen/> :
                <Container style={{width: '60%'}}>
                    {/*<Alert variant={"success"}>{leadsCountText}</Alert>*/}


                    <Bar options={options} data={data}/>


                </Container>
            }
        </>

    )
}
